module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","root":"React","amd":"react"}
// module id = 23
// module chunks = 0